module.exports = __webpack_public_path__ + "static/media/garden.7e3d1c9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/characteristics/garden.svg
// module id = 869
// module chunks = 0